import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import $, { get } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import SurveyContent from "./SurveyContent";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from "./Utils";

class ManageSurvey extends Component {
  constructor(props) {
    super(props);

    const date = new Date();
    var minute = date.getMinutes();
    if (date.getMinutes() > 0 && date.getMinutes() < 10) {
      minute = "0" + date.getMinutes();
    }
    const showCurrentTime = date.getHours() + ":" + minute;

    this.state = {
      healthSystemGroupValue: [],
      startLoader: false,
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      value: [],
      procedureData: "",
      loadedData: [],
      disableAddButton: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      pageNum: null,
      selectedDate: new Date(),
      paginationValue: 10,
      hospitalGroupValue: [],
      scopeGroup: [],
      showSurveyTab: "Hide",
      noSurveyData: false,
      showPublished: true,
      isLoading: true,
      searchTerm: "",
      isEdited: false,
      noMatchingData: false,
      highlightMilestoneButton: {},
      highlightReminder: {},
      tableReady: false,
    };

    this.state.healthSystemId = localStorage.getItem("healthSystemId");
    this.state.hospitalId = localStorage.getItem("hospitalId");
    this.state.serviceLineId = localStorage.getItem("serviceLineId");
    this.setState(this.state);
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.scopeTypes = [];
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.healthSystemDropDownInSurveyRef = React.createRef();
    this.hospitalDropDownInSurveyRef = React.createRef();
  }
  componentDidMount() {
    var thisController = this;
    // console.log(thisController.state.disableAddButton);

    const savedPage = localStorage.getItem("lastSurveyActivePage");
    if (savedPage !== null) {
      thisController.restoredPage = parseInt(savedPage);
      localStorage.removeItem("lastSurveyActivePage");
    } else {
      thisController.restoredPage = 1;
    }

    setTimeout(() => {
      thisController.fetchHealthSystemDetails();
      thisController.fetchScopeType();
      thisController.fetchAllSurveys();
    }, 300);
  }

  fetchScopeType = () => {
    var fetchDataContoller = this;
    $.ajax({
      url: "/my-jeeva-api/scope-type",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          fetchDataContoller.state.showLoader = true;
          fetchDataContoller.setState(fetchDataContoller.state);
          var scopeTypeInfo = res.result;
          var numberOfScopeType = scopeTypeInfo.length;
          fetchDataContoller.scopeTypes = [];
          for (var i = 0; i < numberOfScopeType; i++) {
            if (
              scopeTypeInfo[i]["name"] == "TREATMENT"
            ) {
              fetchDataContoller.scopeTypes.push(scopeTypeInfo[i]);
            }
          }
          fetchDataContoller.fetchScopeGrpTreatment("TREATMENT");
        }
      },
    });
  };

  onChangeScopeType = (row, e) => {
    var scopeType;
    if (row == null || row == undefined) {
      scopeType = this.scopeTypes[0].name;
    } else {
      row.type = e.target.value;
      scopeType = row.type;
    }

    if (scopeType == "HEALTH_SYSTEM") {
      this.fetchScopeGrpHS(scopeType);
      this.setState(this.state);
    } else if (scopeType == "HOSPITAL") {
      this.fetchScopeGrpHospital(scopeType);
      this.setState(this.state);
    } else if (scopeType == "SERVICE_LINE") {
      this.fetchScopeGrpSL(scopeType);
      this.setState(this.state);
    } else if (scopeType == "TREATMENT") {
      this.fetchScopeGrpTreatment(scopeType);
      this.setState(this.state);
    }
  };
  fetchScopeGrpHS = (scopeType) => {
    if (scopeType == null) {
      scopeType = "HEALTH_SYSTEM";
    }
    var fetchDataContoller = this;
    $.ajax({
      url: "/my-jeeva-api/fetch-survey-group",

      method: "GET",
      data: {
        surveyScope: scopeType,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          fetchDataContoller.state.showLoader = true;
          fetchDataContoller.setState(fetchDataContoller.state);
          var scopeGroupInfo = res.result;
          var numberOfScopeGrp = scopeGroupInfo.length;
          fetchDataContoller.state.scopeGroup = [];
          for (var i = 0; i < numberOfScopeGrp; i++) {
            fetchDataContoller.state.scopeGroup[i] = scopeGroupInfo[i];
          }
        }
      },
    });
  };
  fetchScopeGrpHospital = (scopeType) => {
    var thisController = this;
    var healthSystem = thisController.userDetails["healthSystemId"];
    if (healthSystem == null) {
      healthSystem = document.getElementById("healthSystem").value;
    }
    $.ajax({
      url: "/my-jeeva-api/fetch-survey-group",

      method: "GET",
      data: {
        surveyScope: scopeType,
        healthSystemId: healthSystem,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          var scopeGroupInfo = res.result;
          var numberOfScopeGrp = scopeGroupInfo.length;
          thisController.state.scopeGroup = [];
          thisController.setState(thisController.state);
          for (var i = 0; i < numberOfScopeGrp; i++) {
            thisController.state.scopeGroup[i] = scopeGroupInfo[i];
            thisController.setState(thisController.state);
          }
        }
      },
    });
  };
  fetchScopeGrpSL = (scopeType) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var hospitalId = thisController.userDetails["hospitalId"];
    var healthSystemId = thisController.userDetails["healthSystemId"];
    var serviceLineId = thisController.userDetails["serviceLineId"];
    if (serviceLineId == "null" || serviceLineId == null) {
      serviceLineId = "00000000-0000-0000-0000-000000000000";
    }
    if (healthSystemId == null) {
      // healthSystem = document.getElementById("healthSystem").value
      healthSystemId = thisController.state.healthSystemId;
    }
    if (hospitalId == null) {
      // hospitalId = document.getElementById("hospitalDropDown").value
      hospitalId = thisController.state.hospitalId;
    }
    $.ajax({
      url: "/my-jeeva-api/fetch-survey-group",

      method: "GET",
      data: {
        surveyScope: scopeType,
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
        userRole: userRole,
        serviceLineId: serviceLineId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;

          var scopeGroupInfo = res.result;
          var numberOfScopeGrp = scopeGroupInfo.length;
          thisController.state.scopeGroup = [];
          thisController.setState(thisController.state);
          for (var i = 0; i < numberOfScopeGrp; i++) {
            var serviceLineId = thisController.userDetails["serviceLineId"];
            var userRole = thisController.userDetails["userRole"];
            if (userRole == "SERVICELINE_ADMIN" || userRole == "PHYSICIAN") {
              if (scopeGroupInfo[i].id == serviceLineId) {
                thisController.state.scopeGroup[i] = scopeGroupInfo[i];
                thisController.setState(thisController.state);
              }
            } else {
              thisController.state.scopeGroup.push(scopeGroupInfo[i]);
              thisController.setState(thisController.state);
            }
          }
          thisController.setState({
            scopeGroup: res.result
          })
          console.log("The service lines are : ", thisController.state.scopeGroup);
        }
      },
    });
  };

  fetchScopeGrpTreatment = (scopeType) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystem = thisController.userDetails["healthSystemId"];
    var hospital = thisController.userDetails["hospitalId"];
    var serviceLineId = thisController.userDetails["serviceLineId"];
    if (serviceLineId == "null" || serviceLineId == null) {
      serviceLineId = "00000000-0000-0000-0000-000000000000";
    }
    if (healthSystem == null) {
      healthSystem = thisController.state.healthSystemId;
    }
    if (hospital == null) {
      hospital = thisController.state.hospitalId;
    }

    if (userRole == "PHYSICIAN") {
      var providerId = JSON.parse(localStorage.getItem("user_details"))[
        "userId"
      ];
      var hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: hospitalId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(
              (procedure) => !procedure.isDeactivated
            ).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            var numberOfScopeGrp = scopeGroupInfo.length;
            thisController.state.scopeGroup = [];
            thisController.setState(thisController.state);
            for (var i = 0; i < numberOfScopeGrp; i++) {
              if (scopeGroupInfo[i].createdBy != null && scopeGroupInfo[i].createdBy === thisController.userDetails["emailId"]) {
                thisController.state.scopeGroup.push(scopeGroupInfo[i]);
                thisController.setState(thisController.state);
              }
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-survey-group",

        method: "GET",
        data: {
          surveyScope: scopeType,
          healthSystemId: healthSystem,
          hospitalId: hospital,
          serviceLineId: serviceLineId,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(
              (procedure) => !procedure.isDeactivated
            );
            var numberOfScopeGrp = scopeGroupInfo.length;
            thisController.state.scopeGroup = [];
            thisController.setState(thisController.state);
            for (var i = 0; i < numberOfScopeGrp; i++) {
              thisController.state.scopeGroup.push(scopeGroupInfo[i]);
              thisController.setState(thisController.state);
            }
            console.log("The treatments are : ", thisController.state.scopeGroup);
          }
        },
      });
    }
  };
  addEmptyRow = () => {
    console.log("Adding Empty Row");
    var thisController = this;
    thisController.state.paginationValue =
      thisController.state.paginationValue + 5;
    if (thisController.state.pageNum != 0) {
      thisController.setState({ pageNum: 0 });
    }
    var row = {
      id: "",
      name: "",
      type: "",
      surveyGroupId: "",
      typeName: "",
      surveyGroupName: "",
    };
    var allData = [row, ...thisController.state.loadedData];
    thisController.state.loadedData = allData;
    thisController.state.noMatchingData = false;
    thisController.state.disableAddButton = true;
    thisController.setState(thisController.state);

    //To fetch scope group of first scope type, before onchange scope type
    thisController.onChangeScopeType();
  };

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyWorkUnderProgress() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Work under progress
      </b>,
      {
        position: "top-center",
      }
    );
  }

  CustomNoDataComponent = (props) => (
    <div style={{ textAlign: 'center' }}>
      {props.length === 0 ? <p> There are no records for survey</p> :
        <p></p>}

    </div>
  );

  CustomDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Loading ...</p>
    </div>
  );

  showSurveyResultsTabsSettings = (row, e) => {
    localStorage.setItem("surveyId", row.id);
    localStorage.setItem("surveyTitle", row.title);
    localStorage.setItem("SurveyResultsTab", "Hide");
    localStorage.setItem("procedureName", row.surveyGroupName);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastSurveyActivePage", pageToSave);

    this.props.history.push("/projectmgmt/survey/view-results");
  };

  closePatientDataPopUp = () => {
    this.state.editedId = "-1";
    this.setState(this.state);
    this.setState({ showAddSureveyModal: false });
  };


  updateSurveyInfoApi = (row, e) => {
    var updateController = this;
    var title = document.getElementById("titleId" + row.id).innerText.trim();
    var selectGroupValidation = document.getElementById(
      "surveyGroupId" + row.id
    ).options[document.getElementById("surveyGroupId" + row.id).selectedIndex]
      .text;
    var currentDate = new Date();
    var curDate = currentDate.getDate();
    var curMonth = currentDate.getMonth();
    var curYear = currentDate.getFullYear();
    var selectedDate = updateController.state.selectedDate;
    var date = new Date(updateController.state.selectedDate);
    var selDate = date.getDate();
    var selMonth = date.getMonth();
    var selYear = date.getFullYear();
    var titlePattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );
    updateController.setState(updateController.state);
    var updatedData = {
      id: row.id,
      title: title,
      createdByEmail: updateController.userDetails["emailId"],
      createdByName: updateController.userDetails["name"],
      type: document.getElementById("scopeTypeId" + row.id).value,
      surveyGroupId: document.getElementById("surveyGroupId" + row.id).value,
      scheduledDate: date,
      typeName: document.getElementById("scopeTypeId" + row.id).options[
        document.getElementById("scopeTypeId" + row.id).selectedIndex
      ].text,
      surveyGroupName: document.getElementById("surveyGroupId" + row.id)
        .options[
        document.getElementById("surveyGroupId" + row.id).selectedIndex
      ].text,
    };
    if (
      title == "" ||
      date == "" ||
      selectedDate == "" ||
      selectedDate == null
    ) {
      updateController.notifyEmptyFields();
    }
    else if (selectGroupValidation == "Select Scope Group") {
      updateController.notifyEmptyScopeGroup();
    }
    else if (!titlePattern.test(title)) {
      updateController.notifyImproperTitle();
    } else if (selYear < curYear) {
      updateController.notifyImproperDate();
    } else if (selYear == curYear && selMonth < curMonth) {
      updateController.notifyImproperDate();
    } else if (
      selYear == curYear &&
      selMonth == curMonth &&
      selDate < curDate
    ) {
      updateController.notifyImproperDate();
    } else {
      $.ajax({
        url: "/my-jeeva-api/update-survey",

        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        success: function (res) {
          if (res.success === true) {
            updateController.state.editable = true;
            updateController.state.editedId = "-1";
            updateController.state.disabled = false;
            updateController.state.isEdited = false;
            updateController.notifySurveyUpdate();
            updateController.refreshData();
            updateController.setState(updateController.state);
          } else {
            updateController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  notifyEpisodeUpdated() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Episode details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  makeCelledit(row, e) {
    this.fetchScopeGrpTreatment(row.type);
    this.markAsBeingEdited(row.id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    this.state.isEdited = true;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchHealthSystemDetails() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.healthSystemGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.healthSystemGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          if (!thisController.state.healthSystemId) {
            if (totalCount > 0) {
              thisController.state.healthSystemId = res.result[0].id;
              localStorage.setItem(
                "healthSystemId",
                thisController.state.healthSystemId
              );
              setTimeout(() => {
                thisController.onHealthSystemChange({
                  target:
                    thisController.healthSystemDropDownInSurveyRef.current,
                });
              }, 100);
            }
          }
          thisController.setState(thisController.state);
          thisController.fetchHospitalDetails();
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  openPublishPopUp = (row, e) => {
    var thisController = this;

    $.ajax({
      url: "/my-jeeva-api/check-survey-milestone",

      method: "GET",
      data: {
        surveyId: row.id,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          confirmAlert({
            title: "Confirm to publish",
            message: "Are you sure to publish " + row.title + "?",
            buttons: [
              {
                label: "Yes",
                onClick: () => thisController.publishSurvey(row, e),
              },
              {
                label: "No",
              },
            ],
          });
        } else {
          confirmAlert({
            title: "Milestone Link",
            message: "All surveys must be linked to milestones. Please click Continue to link the survey to a milestone",
            buttons: [
              {
                label: "Continue",
                onClick: () => thisController.addSurveyMilestone(row, e)
              },
            ],
          });
        }
      },
    });

  };

  openUnPublishPopUp = (row, e) => {
    confirmAlert({
      title: "Confirm to unpublish",
      message: "Are you sure to unpublish " + row.title + "?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.unPublishSurvey(row, e),
        },
        {
          label: "No",
        },
      ],
    });
  };

  publishSurvey = (row, e) => {
    var publishController = this;
    console.log(row.id);

    $.ajax({
      url: "/my-jeeva-api/publish-survey",

      method: "GET",
      data: {
        surveyId: row.id,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          publishController.notifySurveyPublished(res.result);
          publishController.fetchAllSurveys();
        } else {
          // publishController.notifyError();
        }
      },
    });
  };

  unPublishSurvey = (row, e) => {
    var publishController = this;
    console.log(row.id);

    $.ajax({
      url: "/my-jeeva-api/unpublish-survey",

      method: "GET",
      data: {
        surveyId: row.id,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          publishController.notifySurveyPublished(res.result);
          publishController.fetchAllSurveys();
        } else {
          // publishController.notifyError();
        }
      },
    });
  };

  addSurveyMilestone = (row, e) => {
    localStorage.setItem("surveyTitle", row.title);
    localStorage.setItem("surveyCreatedBy", row.createdByEmail);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastSurveyActivePage", pageToSave);

    this.props.history.push({
      pathname: "/projectmgmt/survey-milestone",
      state: {
        treatmentId: row.surveyGroupId,
        surveyId: row.id,
        surveyName: row.title,
        treatmentName: row.surveyGroupName,
        pageNum: this.state.pageNum,
        createdByEmail: row.createdByEmail,
      },
    });
    this.setState(this.setState);
  };

  addSurveyReminder = (row, e) => {
    localStorage.setItem("surveyTitle", row.title);
    localStorage.setItem("surveyCreatedBy", row.createdByEmail);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastSurveyActivePage", pageToSave);

    this.props.history.push({
      pathname: "/projectmgmt/survey-reminder",
      state: {
        surveyId: row.id,
        pageNum: this.state.pageNum,
        createdByEmail: row.createdByEmail,
      },
    });
    this.setState(this.setState);
  };

  fetchUnPublishedSurvey() {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    thisController.state.loadedData = [];
    var healthSystemId;
    var hospitalId;
    if (userRole == "ADMIN") {
      healthSystemId = localStorage.getItem("healthSystemId");
      hospitalId = localStorage.getItem("hospitalId");
      $.ajax({
        url: "/my-jeeva-api/fetch-survey-root-admin",

        method: "GET",
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success == true) {
            if (res.result.length == 0) {
              thisController.state.noSurveyData = true;
              thisController.state.disableAddButton = false;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noSurveyData = false;
              thisController.state.editable = false;
              thisController.state.disableAddButton = false;
              thisController.state.isLoading = false;
              thisController.state.loadedData = res.result;
              thisController.setState(thisController.state);
            }
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-survey",

        method: "GET",
        data: {
          userEmail: thisController.userDetails["emailId"],
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success == true) {
            if (res.result.length == 0) {
              thisController.state.noSurveyData = true;
              thisController.state.disableAddButton = false;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noSurveyData = false;
              thisController.state.editable = false;
              thisController.state.disableAddButton = false;
              thisController.state.isLoading = false;
              thisController.state.loadedData = res.result;
              thisController.setState(thisController.state);
            }
          }
        },
      });
    }
  }

  fetchAllSurveys() {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    thisController.state.loadedData = [];
    var healthSystemId;
    var hospitalId;
    if (userRole == "ADMIN") {
      healthSystemId = localStorage.getItem("healthSystemId");
      hospitalId = localStorage.getItem("hospitalId");
      $.ajax({
        url: "/my-jeeva-api/fetch-all-survey-root-admin",
        method: "GET",
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success == true) {
            if (res.result.length == 0) {
              thisController.state.noSurveyData = true;
              thisController.state.disableAddButton = false;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noSurveyData = false;
              thisController.state.editable = false;
              thisController.state.disableAddButton = false;
              thisController.state.noMatchingData = false;
              thisController.state.isLoading = false;
              thisController.state.loadedData = res.result;
              if (thisController.state.loadedData.length > 0) {
                thisController.checkSurveyStatusBatch(thisController.state.loadedData);
              }
              thisController.state.pageNum = thisController.restoredPage || 1;
              thisController.state.tableReady = true;
              thisController.setState(thisController.state);
            }
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-all-survey",

        method: "GET",
        data: {
          healthSystemId: thisController.userDetails["healthSystemId"],
          hospitalId: thisController.userDetails["hospitalId"] ? thisController.userDetails["hospitalId"] : thisController.state.hospitalId,
          userEmail: thisController.userDetails["emailId"],
          userId: thisController.userDetails["userId"]
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success == true) {
            if (res.result.length == 0) {
              thisController.state.noSurveyData = true;
              thisController.state.disableAddButton = false;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noSurveyData = false;
              thisController.state.editable = false;
              thisController.state.disableAddButton = false;
              thisController.state.noMatchingData = false;
              thisController.state.isLoading = false;
              thisController.state.loadedData = res.result;
              if (thisController.state.loadedData.length > 0) {
                thisController.checkSurveyStatusBatch(thisController.state.loadedData);
              }
              thisController.state.pageNum = thisController.restoredPage || 1;
              thisController.state.tableReady = true;
              thisController.setState(thisController.state);
            }
          }
        },
      });
    }
  }

  deleteManageSurvey = (id) => {
    let deleteRowViewController = this.state.loadedData;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-survey/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            deleteRowViewController.splice(id, 1);
            deleteApiViewController.refreshData();
          } else {
            // deleteRowViewController.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }

    if (this.state.deleteRow) {
      this.state.loadedData.splice(id, 1);
    }
    //  deleteConstructorVariables.fetchSurvey();
  };

  refreshData = (id) => {
    this.state.isLoading = true;
    this.state.noMatchingData = false;
    this.state.searchTerm = "";
    this.state.isEdited = false;
    this.setState(this.state);
    var refreshContent = this;
    refreshContent = this.state.editedId = id;
    this.fetchAllSurveys();
    this.setState({ disableAddButton: false });
  };

  checkSurveyStatusBatch = (rows) => {
    if (!rows || rows.length === 0) return;

    var statusController = this;
    var surveyIds = rows.map(row => row.id);

    // Call milestone batch API
    $.ajax({
      url: "/my-jeeva-api/survey-status-batch",
      method: "POST",
      data: JSON.stringify(surveyIds),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json"
      },
      dataType: "json",
      success: function (res) {
        if (res.success === true) {
          const milestoneMap = res.result;
          let newHighlightMilestone = {};

          for (const [surveyId, status] of Object.entries(milestoneMap)) {
            newHighlightMilestone[surveyId] = status.hasMilestone || false;
          }

          statusController.setState(prevState => ({
            highlightMilestoneButton: {
              ...prevState.highlightMilestoneButton,
              ...newHighlightMilestone
            }
          }));
        }
      },
    });

    // Call reminder batch API
    $.ajax({
      url: "/my-jeeva-api/survey-reminder-batch",
      method: "POST",
      data: JSON.stringify(surveyIds),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json"
      },
      dataType: "json",
      success: function (res) {
        if (res.success === true) {
          const reminderMap = res.result;
          let newHighlightReminder = {};

          for (const [surveyId, status] of Object.entries(reminderMap)) {
            newHighlightReminder[surveyId] = status.hasReminder || false;
          }

          statusController.setState(prevState => ({
            highlightReminder: {
              ...prevState.highlightReminder,
              ...newHighlightReminder
            }
          }));
        }
      },
    });
  }

  highlightSurveyHasMilestone = (row) => {
    // Fallback for single row check
    this.checkSurveyStatusBatch([row]);
  }

  highlightSurveyHasReminder = (row) => {
    // Fallback for single row check
    this.checkSurveyStatusBatch([row]);
  }

  notifuEpisodeAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Episode added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Survey detail deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifySurveyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Survey updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  onPageChange = (e) => {
    this.restoredPage = e;
    this.setState({ pageNum: e });
    localStorage.setItem("lastSurveyActivePage", e);
  };

  scopeGroupHandleChange = (row, e) => {
    row.title = document.getElementById("titleId" + row.id).innerText;
    row.type = document.getElementById("scopeTypeId" + row.id).value;
    row.typeName = document.getElementById("scopeTypeId" + row.id).options[
      document.getElementById("scopeTypeId" + row.id).selectedIndex
    ].text;
    row.surveyGroupName = document.getElementById(
      "surveyGroupId" + row.id
    ).options[
      document.getElementById("surveyGroupId" + row.id).selectedIndex
    ].text;
    row.surveyGroupId = e.target.value;
    this.setState(this.state);
  };

  onDateChange = (row, date) => {
    row.title = document.getElementById("titleId" + row.id).innerText;
    row.surveyGroupName = document.getElementById(
      "surveyGroupId" + row.id
    ).options[
      document.getElementById("surveyGroupId" + row.id).selectedIndex
    ].text;
    row.surveyGroupId = document.getElementById("surveyGroupId" + row.id).value;
    var selectedDate = `${date.getDate()}/${date.getMonth() + 1
      }/${date.getFullYear()}`;
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    selectedDate = `${month}/${day}/${date.getFullYear()}`;
    row.scheduledDate = date;
    this.state.selectedDate = date;
    this.setState(this.state);
  };

  onTitleChange = (row, e) => {
    row.title = document.getElementById("titleId" + row.id).innerText;
    var date = new Date(
      document.getElementById("launchedDateId" + row.id).value
    );
    row.scheduledDate = date;
    row.type = document.getElementById("scopeTypeId" + row.id).value;
    row.typeName = document.getElementById("scopeTypeId" + row.id).options[
      document.getElementById("scopeTypeId" + row.id).selectedIndex
    ].text;
    row.surveyGroupName = document.getElementById(
      "surveyGroupId" + row.id
    ).options[
      document.getElementById("surveyGroupId" + row.id).selectedIndex
    ].text;
    row.surveyGroupId = e.target.value;
    this.setState(this.state);
  };

  saveSurveyInfoApi = (row, e) => {
    this.state.editedId = "-1";
    this.setState(this.state);
    var thisController = this;
    var currentDate = new Date();
    var curDate = currentDate.getDate();
    var curMonth = currentDate.getMonth();
    var curYear = currentDate.getFullYear();
    row.title = document.getElementById("titleId" + row.id).innerText.trim();
    var date = new Date(
      document.getElementById("launchedDateId" + row.id).value
    );
    var dateForValidation = document.getElementById(
      "launchedDateId" + row.id
    ).value;
    var selectGroupValidation = document.getElementById(
      "surveyGroupId" + row.id
    ).options[document.getElementById("surveyGroupId" + row.id).selectedIndex]
      .text;
    var selectScopeValidation = document.getElementById("scopeTypeId" + row.id)
      .options[document.getElementById("scopeTypeId" + row.id).selectedIndex]
      .text;
    var selDate = date.getDate();
    var selMonth = date.getMonth();
    var selYear = date.getFullYear();
    var titlePattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    if (userRole == "ADMIN") {
      (healthSystemId = localStorage.getItem("healthSystemId")),
        (hospitalId = localStorage.getItem("hospitalId"));
    } else if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      hospitalId = localStorage.getItem("hospitalId");
    } else {
      healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
    }
    if (row.title === "") {
      thisController.notifyEmptyFields();
    } else if (dateForValidation == "") {
      thisController.notifyEmptyFields();
    } else if (!titlePattern.test(row.title)) {
      thisController.notifyImproperTitle();
    } else if (selectGroupValidation == "Select Scope Group") {
      thisController.notifyEmptyScopeGroup();
    } else if (selYear < curYear) {
      thisController.notifyImproperDate();
    } else if (selYear == curYear && selMonth < curMonth) {
      thisController.notifyImproperDate();
    } else if (
      selYear == curYear &&
      selMonth == curMonth &&
      selDate < curDate
    ) {
      thisController.notifyImproperDate();
    } else {
      var addSurveyData = {
        title: row.title,
        createdByEmail: thisController.userDetails["emailId"],
        createdByName: thisController.userDetails["name"],
        type: document.getElementById("scopeTypeId" + row.id).value,
        surveyGroupId: document.getElementById("surveyGroupId" + row.id).value,
        scheduledDate: date,
        typeName: document.getElementById("scopeTypeId" + row.id).options[
          document.getElementById("scopeTypeId" + row.id).selectedIndex
        ].text,
        surveyGroupName: document.getElementById("surveyGroupId" + row.id)
          .options[
          document.getElementById("surveyGroupId" + row.id).selectedIndex
        ].text,
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
      };

      $.ajax({
        url: "/my-jeeva-api/add-survey",

        method: "POST",
        data: JSON.stringify(addSurveyData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },

        success: function (res) {
          if (res.success === true) {
            thisController.state.editable = true;
            thisController.notifySurveyAdded();
            thisController.refreshData();
            thisController.setState({ disabled: false });
          } else {
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };

  notifySurveyPublished(msg) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;{msg}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifySurveyAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;New survey created successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifySurveyCloned() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp; Survey cloned Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyEmptyScopeGroup() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please select the Scope Group
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyWorkingunderprogress() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Working under progress
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperTitle() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid title
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Past dates can't be selected, Please select Today or Future
        date.
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectHospital() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please select hospital.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifySelectHealthSystem() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please select health system.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  addQuestion = (row, e) => {
    localStorage.setItem("surveyCreatedBy", row.createdByEmail);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastSurveyActivePage", pageToSave);

    if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) {
      if (localStorage.getItem("hospitalId") == "") {
        this.notifySelectHospital();
      } else {
        this.props.history.push({
          pathname: "/projectmgmt/add-survey-question",
          state: {
            currentSurveyId: row.id,
            healthSystemId: this.state.healthSystemId,
            hospitalId: this.state.hospitalId,
          },
        });
        this.setState(this.setState);
      }
    } else if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN) {
      var hospitalId = localStorage.getItem("hospitalId");
      if (this.state.healthSystemId == "") {
        this.notifySelectHealthSystem();
      }
      if (hospitalId == "" || hospitalId == null) {
        this.notifySelectHospital();
      } else {
        this.props.history.push({
          pathname: "/projectmgmt/add-survey-question",
          state: {
            currentSurveyId: row.id,
            healthSystemId: this.state.healthSystemId,
            hospitalId: this.state.hospitalId,
          },
        });
        this.setState(this.setState);
      }
    } else {
      this.props.history.push({
        pathname: "/projectmgmt/add-survey-question",
        state: {
          currentSurveyId: row.id,
          healthSystemId: this.state.healthSystemId,
          hospitalId: this.state.hospitalId,
        },
      });
      this.setState(this.setState);
    }
  };

  fetchHospitalDetails() {
    var thisController = this;
    var responseData = [];
    var healthSystemId;
    var userRole = thisController.userDetails["userRole"];
    if (
      userRole == "HEALTHSYSTEM_ADMIN" ||
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else {
      healthSystemId = thisController.state.healthSystemId;
    }
    var hospitalFetchPromise = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/hospital",

        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: healthSystemId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.state.hospitalGroupValue = [];
            thisController.setState(thisController.state);
            responseData = res.result;
            var totalCount = responseData.length;
            thisController.state.hospitalGroupValue = [];
            for (var i = 0; i < totalCount; i++) {
              thisController.state.hospitalGroupValue.push({
                name: res.result[i].name,
                value: res.result[i].id,
              });
            }

            thisController.setState(thisController.state);
            if (
              localStorage.getItem("hospitalId") == "" ||
              thisController.state.hospitalId == null
            ) {
              if (totalCount > 0) {
                thisController.state.hospitalId = res.result[0].id;
                localStorage.setItem(
                  "hospitalId",
                  thisController.state.hospitalId
                );
                setTimeout(() => {
                  thisController.onHospitalChange({
                    target: thisController.hospitalDropDownInSurveyRef.current,
                  });
                }, 100);
              }
            }
            if (resolve) {
              resolve();
            }
          } else {
            if (resolve) {
              resolve();
            }
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          if (xhr.status == 401) {
            window.location.href = "";
          }
          if (reject) {
            reject();
          }
        },
      });
    });

    return hospitalFetchPromise;
  }

  onHealthSystemChange = (e) => {
    // this.state.isLoading = true;
    // this.setState(this.state);
    var selectBox = e.target;
    localStorage.setItem("hospitalId", "");
    localStorage.setItem("hospitalName", "");
    this.state.dontOverLap = true;
    if (this.state.healthSystemId != selectBox.value) {
      this.state.hospitalId = null;
      localStorage.setItem(`hospitalName`, null);
    }
    this.state.healthSystemId = selectBox.value;
    localStorage.setItem("healthSystemId", this.state.healthSystemId);
    var healthSystemName = selectBox.options[selectBox.selectedIndex].innerText;
    localStorage.setItem("healthSystemName", healthSystemName);
    this.setState(this.state);
    window.surveyNavBarController.paintPatientAdmissionHeading();
    this.fetchHospitalDetails();
    this.state.hospitalId = document.getElementById("hospitalDropDown").value;
  };

  onHospitalChange = (e) => {
    this.state.isLoading = true;
    this.state.loadedData = [];
    this.state.scopeGroup = [];
    this.setState(this.state);
    var selectBox = e.target;
    this.state.dontOverLap = true;
    if (this.state.hospitalId != selectBox.value) {
      this.state.serviceLineId = null;
    }
    this.state.hospitalId = selectBox.value;
    if (selectBox.value != "") {
      var hospitalName = selectBox.options[selectBox.selectedIndex].innerText;
      localStorage.setItem("hospitalName", hospitalName);
    }
    localStorage.setItem("hospitalId", this.state.hospitalId);
    this.setState(this.state);
    window.surveyNavBarController.paintPatientAdmissionHeading();
    this.fetchAllSurveys();
    this.fetchScopeGrpTreatment("TREATMENT")
  };

  openDeletePopUp = (row) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete ${row.title}?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteManageSurvey(row.id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleCheckBoxChange = (e) => {
    this.state.showPublished = !this.state.showPublished;
    this.setState(this.state);
    this.refreshData();
    console.log(e.target.checked);
  };

  openClonePopUp = (row) => {
    confirmAlert({
      title: 'Confirm to clone survey ',
      message: 'Are you sure you want to clone this survey ? ',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.handleCloneSurvey(row)
        },
        {
          label: 'No',
        }
      ]
    });
  }

  handleCloneSurvey = (surveyRow) => {
    const userDetails = this.userDetails;
    var healthSystemId = localStorage.getItem("healthSystemId");
    var hospitalId = localStorage.getItem("hospitalId");
    console.log("cloning survey for : ", userDetails.emailId);
    var surveyData = {};
    surveyData.id = surveyRow.id;
    surveyData.title = surveyRow.title;
    surveyData.surveyGroupName = surveyRow.surveyGroupName;
    surveyData.surveyGroupId = surveyRow.surveyGroupId;
    surveyData.type = surveyRow.type;
    surveyData.typeName = surveyRow.typeName;
    surveyData.scheduledDate = surveyRow.scheduledDate;
    surveyData.createdByName = userDetails.name;
    surveyData.createdByEmail = userDetails.emailId;
    surveyData.healthSystemId = healthSystemId || userDetails.healthSystemId;
    surveyData.hospitalId = hospitalId || userDetails.hospitalId;

    this.cloneSurvey(surveyData);
  };

  cloneSurvey = (survey) => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/clone-survey",
      method: "POST",
      data: JSON.stringify(survey),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },

      success: function (res) {
        if (res.success === true) {
          thisController.state.editable = true;
          thisController.notifySurveyCloned();
          thisController.refreshData();
          thisController.setState({ disabled: false });
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };


  caseInsensitiveSort = (field) => (rowA, rowB) => {
    var a;
    var b;
    if (field === "scheduledDate") {
      a = rowA[field] || '';
      b = rowB[field] || '';
    } else {
      a = rowA[field] ? rowA[field].toLowerCase() : '';
      b = rowB[field] ? rowB[field].toLowerCase() : '';
    }

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.loadedData = [];
    thisController.setState(thisController.state);
    if (event.target.value == "") {
      thisController.state.noMatchingData = false;
      thisController.setState(thisController.state);
      thisController.fetchAllSurveys();

    } else {
      var userRole = thisController.userDetails["userRole"];
      var healthSystemId;
      var hospitalId;
      if (userRole == "ADMIN") {
        healthSystemId = localStorage.getItem("healthSystemId");
        hospitalId = localStorage.getItem("hospitalId");
      } else if (userRole == "HEALTHSYSTEM_ADMIN") {
        healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
          "healthSystemId"
        ];
        hospitalId = localStorage.getItem("hospitalId");
      } else {
        healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
          "healthSystemId"
        ];
        hospitalId = JSON.parse(localStorage.getItem("user_details"))[
          "hospitalId"
        ];
      }

      var userEmail = thisController.userDetails["emailId"];


      $.ajax({
        url: "/my-jeeva-api/search-survey-data",
        method: "GET",
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          searchTerm: thisController.state.searchTerm,
          userRole: userRole,
          userEmail: userEmail
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },

        success: function (res) {
          if (res.success === true) {
            if (res.result.length > 0) {
              thisController.state.loadedData = [];
              thisController.setState(thisController.state);
              thisController.state.loadedData = res.result;
              thisController.state.noMatchingData = false;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noMatchingData = true;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            }
          }
        },
        error: function (xhr) {

        },
      });
    }
  };

  clearSearchData = () => {
    var thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      thisController.fetchHealthSystemDetails();
      thisController.fetchScopeType();
      thisController.fetchAllSurveys();
    });
}


  render() {
    const { loadedData } = this.state;
    console.log("The available scope groups are : ", this.state.scopeGroup);
    const survey_column = [
      {
        name: <b style={{ fontSize: "16px" }}>Title</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('title'),
        selector: (row) => {
          const userDetails = JSON.parse(localStorage.getItem('user_details'));
          let backgroundColor = "white";
          let tooltipText = "";

          if (userDetails && userDetails.userRole === "PHYSICIAN") {
            const emailId = userDetails.emailId;
            backgroundColor = row.createdByEmail !== emailId && row.id !== "" ? 'lightblue' : 'white';
            tooltipText = row.createdByEmail !== emailId && row.id !== "" ? "Read-only survey defined by admin" : "";
          }

          return (
            <div name="name">
              <div
                className="textarea"
                style={{
                  background: backgroundColor,
                  height: "2.7em",
                  resize: "none",
                  paddingLeft: "2px",
                  paddingTop: "6px",
                  width: "98%",
                  color: "#007bff",
                  border:
                    row.id == "" || row.id == this.state.editedId
                      ? "1px solid #D2D4DC"
                      : "none",
                  borderRadius: row.id == "" ? "2px" : "none",
                  cursor: this.state.disableAddButton
                    ? ""
                    : row.isPublished
                      ? ""
                      : row.id == this.state.editedId
                        ? ""
                        : "pointer",
                }}
                id={"titleId" + row.id}
                contentEditable={
                  !(row.id == "" ? false : row.id != this.state.editedId)
                    ? "plaintext-only"
                    : false
                }
                onClick={(e) =>
                  this.state.disableAddButton
                    ? ""
                    : row.isPublished
                      ? ""
                      : row.id == this.state.editedId
                        ? ""
                        : this.addQuestion(row, e)
                }
                title={tooltipText}
              >
                {row.title}
              </div>
            </div>
          );
        },
      },

      {
        name: <b style={{ fontSize: "16px" }}>Creation Date</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('scheduledDate'),
        selector: (row) => (
          <div style={{ display: "flex", alignItems: "center" }} className="survey-launch-date">
            <DatePicker
              disabled={row.id == "" ? false : row.id != this.state.editedId}
              portalId="root"
              style={{
                width: "10px",
                marginLeft: "70%",
                cursor: "pointer",
                border: "white",
                fontSize: "10pt",
                borderBottom: "none"
              }}
              autoOk={true}
              id={"launchedDateId" + row.id}
              value={this.state.selectedDate}
              placeholderText={"Please select a date"}
              selected={row.scheduledDate}
              onChange={(e) => this.onDateChange(row, e)}
              dateFormat="MM/dd/yyyy"
            ></DatePicker>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}> Scope Type</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('typeName'),
        selector: (row) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                display: !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "none"
                  : "block",
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "98%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.typeName}
            </div>
            <select
              className="input-group form-control select2 "
              // onChange={(e) => this.onChangeScopeType(row, e)}
              value={row.type}
              id={"scopeTypeId" + row.id}
              style={{
                display: !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "block"
                  : "none",
                background: "white",
                border: "none",
                border:
                  row.id == undefined || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == undefined ? "2px" : "none",
              }}
              disabled={row.id == "" ? false : row.id != this.state.editedId}
            >
              {this.scopeTypes.map((scopeTypeInfo) => (
                <option key={scopeTypeInfo} value={scopeTypeInfo["name"]}>
                  {scopeTypeInfo["code"]}
                </option>
              ))}
              <option hidden value="Select Scope Type">
                Select Scope Type
              </option>
            </select>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Scope Group</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('surveyGroupName'),
        selector: (row) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                display: !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "none"
                  : "block",
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "98%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.surveyGroupName}
            </div>
            <select
              className="input-group form-control select2 "
              onChange={(e) => this.scopeGroupHandleChange(row, e)}
              value={row.surveyGroupId || ""}
              id={"surveyGroupId" + row.id}
              name={"surveyGroupIdByName" + row.id}
              style={{
                display: !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "block"
                  : "none",
                background: "white",
                border: "none",
                border:
                  row.id == undefined || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == undefined ? "2px" : "none",
              }}
              disabled={row.id == "" ? false : row.id != this.state.editedId}
            >
              <option value="">
                Select Scope Group
              </option>
              {/* The fetched list leaves out deactivated treatments and, for a provider, ones
                  they did not create - keep the survey's current group so editing shows it. */}
              {row.id !== "" && row.surveyGroupId &&
                !this.state.scopeGroup.some((scopeGroupnames) => scopeGroupnames.id === row.surveyGroupId) && (
                  <option key={row.surveyGroupId} value={row.surveyGroupId}>
                    {row.surveyGroupName}
                  </option>
                )}
              {this.state.scopeGroup.map((scopeGroupnames) => (
                <option key={scopeGroupnames.id} value={scopeGroupnames.id}>
                  {scopeGroupnames.name}
                </option>
              ))}
            </select>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Actions</b>,
        width: 200,
        selector: (row) => (
          <div id="action" style={{ marginTop: "12px" }}>
            <button
              style={{ backgroundColor: "#ffffff", border: "none" }}
              hidden={row.isPublished == true ? true : false}
              onClick={row.id !== "" && this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail ? null : (e) => {
                  row.id == ""
                    ? this.saveSurveyInfoApi(row, e)
                    : row.id == this.state.editedId
                      ? this.updateSurveyInfoApi(row, e)
                      : this.makeCelledit(row, e);
                }}
            >
              <img
                className="img-responsive"
                title={row.id !== "" && this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail ? "Clone survey to edit" :
                  row.id == "" || row.id == this.state.editedId
                    ? "Save"
                    : "Edit"
                }
                disabled={
                  row.id !== "" &&
                  (this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail)
                }

                style={{
                  marginTop: "6px",
                  backgroundColor:
                    row.id === ""
                      ? "#282a65"
                      : (this.userDetails["userRole"] === "PHYSICIAN" &&
                        JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail)
                        ? "#282a6596"
                        : "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  row.id == ""
                    ? this.saveImageSrc
                    : row.id != this.state.editedId
                      ? this.editImageSrc
                      : this.saveImageSrc
                }
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display:
                  window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    ? row.id == "" || row.id == this.state.editedId
                      ? "none"
                      : "inline"
                    : "none",
              }}
              onClick={(e) => {
                !row.id == ""
                  ? this.openClonePopUp(row)
                  : () => console.log("empty row");
              }}
            // disabled={this.state.discontinued}
            >
              <img
                className="img-responsive"
                title="Clone"
                style={{
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/copy-64.png"
              />
            </button>

            {/* Mile stone Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                padding: "0px",
                marginLeft: "4px",
                display: row.id == "" || row.id == this.state.editedId ? "none" : "inline"
              }}
              title="Treatment Milestone"
              onClick={(e) => {
                this.addSurveyMilestone(row, e);
              }}
            >
              <img
                className="img-responsive"
                src={"./assets/images/milestone.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: this.state.highlightMilestoneButton[row.id] ? "rgb(5 162 47)" : "#282a65",
                  // backgroundColor: this.state.discontinued ? "#282a6596" : "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                  height: "2rem"
                }}
              />
            </button>
            {/* Mile stone Button ends */}


            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "8px",
                display:
                  window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    ? row.id == "" || row.id == this.state.editedId
                      ? "none"
                      : "inline"
                    : "none",

              }}
              title="Notification"
            >
              <img
                className="img-responsive"
                src={"./assets/images/alarm-clock-24.png"}
                style={{
                  marginTop: "-19px",
                  backgroundColor:
                    this.state.highlightReminder[row.id] ? "rgb(5 162 47)" : "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={
                  (e) => {
                    this.addSurveyReminder(row, e);
                  }}
              />
            </button>

            {row.isPublished === true ? (
              <button
                className="btn2 table-action-button "
                onClick={
                  // this.userDetails["userRole"] === "PHYSICIAN" &&
                  // JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail ? null : 
                  (e) => {
                    this.showSurveyResultsTabsSettings(row, e);
                  }}
                hidden={row.id == "" ? true : false}
              >
                View Results
              </button>
            ) : (
              <button
                className="btn2 table-action-button "
                style={{
                  backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail)
                    ? "#282a6596"
                    : "#282a65",
                }}
                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail ? null : (e) => {
                    this.openPublishPopUp(row, e);
                  }}
                hidden={row.id == "" ? true : false}
                disabled={this.state.isEdited}
              >
                Publish
              </button>
            )}
            <button
              className="btn2 table-action-button "
              style={{
                backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail)
                  ? "#282a6596"
                  : "#282a65",
              }}
              onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail ? null : (e) => {
                  this.openUnPublishPopUp(row, e);
                }}
              hidden={!row.isPublished ? true : false}
            >
              UnPublish
            </button>
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-9px",
              }}
              title={this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail ? "Clone survey to edit" : "Delete"}

              disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail}
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== row.createdByEmail
                    ? "#282a6596"
                    : "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={() =>
                  row.id === ""
                    ? this.refreshData()
                    : this.openDeletePopUp(row)
                }
              />
            </button>
          </div>
        ),
        width: 200,
      },
    ];
    return (
      <div style={{ marginRight: "1%" }} id="manageSurvey">
        <div style={{ background: "#F9F9FB" }}>
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />

          <div className="row">
            <div className="col-sm-3">
              {/* <h6
                className="nav-item"
                style={{ color: "#282a65", marginTop: "1vh" }}
              >
                Manage Surveys
              </h6> */}
            </div>
            <div className="col-sm-6" Align="right" style={{ marginLeft: "-11vw" }}>
              <label
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Health System
              </label>

              <select
                value={this.state.healthSystemId}
                id="healthSystem"
                className="healthSystem"
                onChange={(e) => this.onHealthSystemChange(e)}
                placeholder="Select Health System"
                ref={this.healthSystemDropDownInSurveyRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.healthSystemGroupValue.map((healthSystem) => (
                  <option value={healthSystem.value}>
                    {healthSystem.name}
                  </option>
                ))}
              </select>
              <label
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                  marginLeft: "2vh",
                }}
              >
                Hospital
              </label>
              <select
                value={this.state.hospitalId}
                id="hospitalDropDown"
                className="hospital"
                onChange={(e) => this.onHospitalChange(e)}
                placeholder="Select hospital"
                ref={this.hospitalDropDownInSurveyRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >

                {this.state.hospitalGroupValue.map((hospitalGroup) => (
                  <option value={hospitalGroup.value}>
                    {hospitalGroup.name}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{ marginLeft: "2vw",
              //  marginTop: "-0.4vh" 
            }}>
              <input
                type="text"
                style={{
                  width: "10vw",
                  border: "1px solid #777676",
                  borderRadius: "3px",
                  padding: "10px",
                  height: "0.6vw",
                  paddingRight: "2rem",
                }}
                value={this.state.searchTerm}
                onChange={this.handleSearch}
                placeholder="Search ..."
              />
              {this.state.searchTerm && (
                <span
                  onClick={() => this.clearSearchData()}
                  style={{
                    // position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#777676",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    lineHeight: 1,
                    userSelect: "none",
                    marginLeft: "-1vw"
                  }}
                >
                  ×
                </span>
              )}
            </div>
            <div
              // className="col-sm-3" 
              style={{ marginTop: "-24px", marginLeft: "5vw" }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div
                  className="p-2"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    marginRight: "5rem",
                  }}
                >
                  <button
                    className="btn action-button"
                    id="addMsg"
                    title=" Add "
                    onClick={
                      this.state.disableAddButton
                        ? this.notifyMsgFieldEmpty
                        : this.addEmptyRow
                    }
                  >
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                    style={{ marginRight: "1rem" }}
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ textAlign: "left" }}>
            <div className="col-lg-12 ">

              <div className="card">
                {this.state.isLoading && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading ...</p>
                  </div>
                )}
                {!this.state.isLoading && this.state.loadedData.length === 0 && !this.state.noMatchingData && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>There are no records for survey</p>
                  </div>
                )}
                {(loadedData && !this.state.noMatchingData) && (
                  <DataTable
                    key={"table-" + this.state.pageNum}
                    data={loadedData}
                    columns={survey_column}
                    defaultPageSize={5}
                    pageSizeOptions={[5, 10, 15]}
                    onChangePage={this.onPageChange}
                    paginationDefaultPage={this.state.pageNum || 1}
                    pagination={this.state.paginationValue}
                    noDataComponent={<this.CustomNoDataComponent props={loadedData} />}

                  />
                )}

              </div>
              <ToastContainer className="Toast-at-center" />
            </div>
          </div>
          <div className='card'>
            {this.state.noMatchingData &&
              <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                <p>No matching options found ...</p>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}
export default ManageSurvey;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ManageSurvey.js